import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  sGetDocumentsToSigned,
  sGetOwnedProperties,
  sGetPropertyByBoligmappaNumber,
  sGetPropertyCompanyStats,
  sGetPropertyDocumentStatistics,
  sGetPropertyValueEstimates,
  sGetPropertyValueIncreases,
  sGetSharedPrivatelyProperties,
} from '@/store/reducers/properties';
import PropertiesOverview from '@componentsV2/PropertiesOverview';
import ActivitiesList from '@componentsV2/ActivitiesList';
import ValueEstimateOverview from '@componentsV2/ValueEstimateOverview';
import MainFeatures from '@componentsV2/MainFeatures';
import { getDashboardLinkPrefix } from '@/utils/routes';
import VendorsGrid from '@componentsV2/VendorsGrid';
import { sGetUser } from '@/store/reducers/auth';
import AdCarousel from '@componentsV2/AdCarousel';
import useFetchEffect from '@/hooks/useFetchEffect';
import { useSanityContent } from '@hooksV2/useSanityContent';
import documentsToSignImage from '@/assets/images/documentsToSignImage.png';
import DocumentsPageIntro from '@componentsV2/DocumentsPageIntro';
import HousingProfessionals from '@componentsV2/HousingProfessionals';
import { fetchConsents as apiFetchConsents } from '@/api/propertyowners';
import { sGetUserNotifications } from '@/store/reducers/notifications';
import { Link } from 'react-router-dom';
import {
  getPropertyAddress,
  getPropertyOwnerSubscriptionStatus,
} from '@/utils/properties';
// import PersonalFolderIntro from '@componentsV2/PersonalFolderIntro';
// import { fetchPersonalDocuments as apiFetchPersonalDocuments } from '@/api/propertyowners';
// import { sGetPersonalDocuments } from '@/store/reducers/personalDocuments';
// import {
//   acSetFetchingPersonalDocuments,
//   acSetFetchingPersonalDocumentsError,
//   acSetPersonalDocuments,
// } from '@/store/actions/personalDocuments';
import { acSetIsMarketingConsentGranted } from '@/store/actions/marketEvents';
import { sGetIsMarketingConsentGranted } from '@/store/reducers/marketEvents';
import { MARKETINGEMAIL } from '@/constants';

const GlobalDashboard = ({
  authUser,
  ownedProperties,
  sharedProperties,
  user,
  documentsToSigned,
  getPropertyByBoligmappaNumber,
  propertyValueIncreases,
  propertyValueEstimates,
  propertyDocumentStatistics,
  propertyCompanyStats,
  userNotifications,
  // personalDocuments,
  // setPersonalDocuments,
  // setPersonalDocumentFetching,
  // setPersonalDocumentFetchingError,
  isMarketingConsentGranted,
  setIsMarketingConsentGranted,
}) => {
  const [carouselItems, setCarouselItems] = useState([]);

  const sanityData = useSanityContent();

  const adCarouselData = {
    id: 1,
    image: documentsToSignImage,
    title: 'Tilstandsrapport til signering',
    pathName: `/dashboard/${documentsToSigned?.[0]?.boligmappaNumber}/condition`,
    paragraph: `Tilstandsrapport fra ${
      documentsToSigned?.[0]?.companyName
    } til signering for ${getPropertyAddress(
      getPropertyByBoligmappaNumber(documentsToSigned?.[0]?.boligmappaNumber)
    )} med BankID er nå klar.`,
    buttonText: 'Sjekk ut',
    isForDocumentToSign: true,
  };

  const boligmappaPlusSubscriptionStatus =
    getPropertyOwnerSubscriptionStatus(authUser);

  const allProperties = [
    ...(ownedProperties || []),
    ...(sharedProperties || []),
  ];

  const onAdCarouselSlideClose = (index) => {
    setCarouselItems((prev) => prev.filter((item, i) => i !== index));
  };

  const getConsentByType = (data, type) =>
    (data || []).find((item) => item.type === type);

  useFetchEffect({
    conditionFunction: () => isMarketingConsentGranted === null,
    apiFetchFunction: apiFetchConsents,
    onSuccess: (data) =>
      setIsMarketingConsentGranted(
        (getConsentByType(data, MARKETINGEMAIL) || { isGranted: false })
          .isGranted
      ),
  });

  useEffect(() => {
    if (boligmappaPlusSubscriptionStatus !== undefined) {
      setCarouselItems(
        [adCarouselData, ...sanityData.globalDashboardInfoSliderContent].filter(
          (item) =>
            (!boligmappaPlusSubscriptionStatus ||
              item.condition !== 'isNotForBmPlusSub') &&
            (!isMarketingConsentGranted ||
              item.condition !== 'notSubNewsletter') &&
            (!!documentsToSigned?.length || !item.isForDocumentToSign)
        )
      );
    }
  }, [
    documentsToSigned,
    boligmappaPlusSubscriptionStatus,
    isMarketingConsentGranted,
  ]);

  return (
    <div className="px-[15px] py-8 md:py-10">
      <div className="flex flex-col max-w-screen-md mx-auto font-circular">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-medium md:my-4">
            Hei, {user?.firstName}!
          </h2>
          <Link
            className="text-[15px] opacity-[50%] font-medium"
            to="/personal-area/dashboard/more/account"
          >
            Gå til <span className="border-b border-black">din konto ›</span>
          </Link>
        </div>
        <AdCarousel
          items={carouselItems}
          onAdCarouselSlideClose={onAdCarouselSlideClose}
        />
        <div className="flex flex-col gap-10 my-4">
          <PropertiesOverview
            allProperties={allProperties}
            propertyDocumentStatistics={
              propertyDocumentStatistics && [
                ...propertyDocumentStatistics.ownedProperties,
                ...propertyDocumentStatistics.sharedProperties,
              ]
            }
          />
          <ActivitiesList
            items={
              userNotifications &&
              userNotifications.map((el) => ({
                id: el.ids[0],
                title: el.title,
                date: el.createdDate,
              }))
            }
          />
          <DocumentsPageIntro
            getPropertyByBoligmappaNumber={getPropertyByBoligmappaNumber}
            propertyDocumentStatistics={
              propertyDocumentStatistics && [
                ...propertyDocumentStatistics.ownedProperties,
                ...propertyDocumentStatistics.sharedProperties,
              ]
            }
          />
          {/* {boligmappaPlusSubscriptionStatus && ( */}
          {/*   <PersonalFolderIntro personalDocuments={personalDocuments} /> */}
          {/* )} */}
          <ValueEstimateOverview
            isBlurred={!boligmappaPlusSubscriptionStatus}
            allProperties={allProperties}
            valueIncreases={
              propertyValueIncreases && [
                ...propertyValueIncreases.ownedPropertyPriceHistories,
                ...propertyValueIncreases.sharedPropertyPriceHistories,
              ]
            }
            valueEstimates={
              propertyValueEstimates && [
                ...propertyValueEstimates.ownedPropertyValueEstimate,
                ...propertyValueEstimates.sharedPropertyValueEstimate,
              ]
            }
          />
          {/* Todo: use HousingProfessionals component when backend is ready */}
          <HousingProfessionals
            allProperties={allProperties}
            propertyCompanyStats={propertyCompanyStats}
            dashboardLinkPrefix={getDashboardLinkPrefix(
              allProperties[0]?.boligmappaNumber
            )}
          />
          <MainFeatures
            dashboardLinkPrefix={getDashboardLinkPrefix(
              allProperties[0]?.boligmappaNumber
            )}
          />
          <VendorsGrid
            dashboardLinkPrefix={getDashboardLinkPrefix(
              allProperties[0]?.boligmappaNumber
            )}
          />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  authUser: sGetUser(state),
  ownedProperties: sGetOwnedProperties(state),
  sharedProperties: sGetSharedPrivatelyProperties(state),
  user: sGetUser(state),
  documentsToSigned: sGetDocumentsToSigned(state),
  isMarketingConsentGranted: sGetIsMarketingConsentGranted(state),
  getPropertyByBoligmappaNumber: (boligmappaNumber) =>
    sGetPropertyByBoligmappaNumber(state, boligmappaNumber),
  propertyValueIncreases: sGetPropertyValueIncreases(state),
  propertyValueEstimates: sGetPropertyValueEstimates(state),
  propertyDocumentStatistics: sGetPropertyDocumentStatistics(state),
  propertyCompanyStats: sGetPropertyCompanyStats(state),
  userNotifications: sGetUserNotifications(state),
  // personalDocuments: sGetPersonalDocuments(state),
});

const mapDispatchToProps = (dispatch) => ({
  setIsMarketingConsentGranted: (data) =>
    dispatch(acSetIsMarketingConsentGranted(data)),
  // setPersonalDocumentFetching: (fetching) =>
  //   dispatch(acSetFetchingPersonalDocuments(fetching)),
  // setPersonalDocumentFetchingError: (fetchingError) =>
  //   dispatch(acSetFetchingPersonalDocumentsError(fetchingError)),
  // setPersonalDocuments: (documents) =>
  //   dispatch(acSetPersonalDocuments(documents)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalDashboard);
